(function () {
  class SolaraParasolEnhancements {
    constructor() {
      this.addToCartLabel = window.variantStrings?.addToCart || 'Add to cart';
      this.patchVariantData();
      this.enablePurchaseControls();
      this.bindEvents();
    }

    bindEvents() {
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
        subscribe(window.PUB_SUB_EVENTS.variantChange, () => {
          window.requestAnimationFrame(() => this.enablePurchaseControls());
        });
      }
    }

    patchVariantData() {
      document
        .querySelectorAll('variant-radios script[type="application/json"], variant-selects script[type="application/json"]')
        .forEach((script) => {
          try {
            const variants = JSON.parse(script.textContent);
            variants.forEach((variant) => {
              variant.available = true;
            });
            script.textContent = JSON.stringify(variants);
          } catch (error) {
            console.warn('Parasolune parasol: could not patch variant data', error);
          }
        });

      document.querySelectorAll('variant-radios input[type="radio"].disabled').forEach((input) => {
        input.classList.remove('disabled');
      });
    }

    enablePurchaseControls() {
      document.querySelectorAll('.product-form__submit').forEach((button) => {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        const label = button.querySelector('span');
        if (label) {
          const text = label.textContent.trim().toLowerCase();
          if (text.includes('sold out') || text.includes('unavailable')) {
            label.textContent = this.addToCartLabel;
          }
        }
      });

      document.querySelectorAll('.product-variant-id').forEach((input) => {
        input.removeAttribute('disabled');
      });
    }
  }

  if (document.body.classList.contains('solara-parasol-product')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => new SolaraParasolEnhancements());
    } else {
      new SolaraParasolEnhancements();
    }
  }
})();
